/* eslint-disable default-case */
import React from "react";
import axios from "axios";
import "react-notifications/lib/notifications.css";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import FileUploader from "../../components/common/FileUploader";
import { Button } from "shards-react";

class EditWhatsNew extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      image: "",
    };
  }
  fileSelectedHandler = (event) => {
    this.setState({
      selectedFile: event.target.files[0],
    });
  };

  onChange = (e) => {
    this.setState({ [e.target.id]: e.target.value });
  };
  createNotification = (type) => {
    switch (type) {
      case "info":
        NotificationManager.info("Info message", 1000);
        break;
      case "success":
        NotificationManager.success(
          "Success message",
          "Successfully Post",
          1000
        );
        break;
      case "warning":
        NotificationManager.warning(
          "Warning message",
          "Close after 3000ms",
          1000
        );
        break;
      case "error":
        NotificationManager.error(
          "Error message",
          "Something is wrong! Retry again",
          1000,
          () => {
            alert("callback");
          }
        );
        break;
    }
  };
  getNews = () => {
    const id = localStorage.getItem("id");

    axios
      .get(`${process.env.REACT_APP_API_URL}/whatsNew/` + id, {
        headers: { "x-access-token": localStorage.getItem("jwtToken") },
      })
      .then((res) => {
        this.setState({
          data: res.data.data,
          image: res.data.data[0].cover,
        });
      });
  };
  componentDidMount() {
    this.getNews();
  }
  onSubmit = (e) => {
    const id = localStorage.getItem("id");
    e.preventDefault();
    if (this.state.image === "") {
      this.createNotification("error");
    } else {
      axios
        .put(
          `${process.env.REACT_APP_API_URL}/WhatsNew/` + id,
          {
            cover: this.state.image,
            description: e.target.desc.value,
            link: e.target.link.value,
            card_type: e.target.cardType.value,
            order_by: parseInt(e.target.order_by.value),
          },
          { headers: { "x-access-token": localStorage.getItem("jwtToken") } }
        )
        .then((res) => {
          if (res.status === 200) {
            this.createNotification("success");
          } else {
            this.createNotification("error");
          }
        });
      window.location.href = "/whats-new";
    }
  };

  render() {
    return (
      <React.Fragment>
        <NotificationContainer />
        <section className="hero-section pt-50 pb-50">
          <div className="container">
            <div className="col-md-12 col-lg-12 ">
              <h1 className="event-title">Edit Whats new block</h1>
              <div className="card login-signup-card shadow-lg mb-0">
                <div className="card-body px-md-5 py-5">
                  {this.state.data.map((item, index) => (
                    <form key={index} onSubmit={this.onSubmit}>
                      <label className="pb-1">Card type:</label>
                      <select
                        className="form-control"
                        name="cardType"
                        defaultValue={item.card_type}
                      >
                        <option value="img-txt-link">
                          Image, text and link
                        </option>
                        <option value="image-text">Image and text</option>
                        <option value="image">Text only</option>
                      </select>
                      <label className="pb-1" for="blockOrder">
                        Block Order:{" "}
                      </label>
                      <div className="input-group input-group-merge">
                        <input
                          defaultValue={item.order_by}
                          onChange={this.onChange}
                          id="blockOrder"
                          type="number"
                          name="order_by"
                          className="form-control"
                          placeholder="Enter block order"
                          required
                        />
                      </div>
                      <label className="pb-1">Event Cover Image</label>
                      <FileUploader
                        label="Upload New Cover"
                        onUploadSuccess={(imagePath) =>
                          this.setState({ image: imagePath })
                        }
                        onError={(message) => this.createNotification("error")}
                      />
                      <div>
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          href={this.state.image}
                        >
                          {this.state.image}
                        </a>
                      </div>

                      <label className="pb-1"> Description</label>
                      <div className="input-group input-group-merge">
                        <textarea
                          defaultValue={item.description}
                          onChange={this.onChange}
                          type="textarea"
                          name="desc"
                          className="form-control"
                          rows={5}
                          placeholder=""
                          required
                        />
                      </div>
                      <div className="input-group input-group-merge">
                        <div></div>
                      </div>
                      <label className="pb-1">Website link :</label>
                      <div className="input-group input-group-merge">
                        <input
                          defaultValue={item.link}
                          onChange={this.onChange}
                          id="link"
                          type="text"
                          name="link"
                          className="form-control"
                          placeholder="Enter website link"
                          required
                        />
                      </div>

                      <Button type="submit" className="submit-btn">
                        Submit
                      </Button>
                    </form>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}
export default EditWhatsNew;
